import type { CSSProperties } from "react";

export const orderInputStyle: CSSProperties = {
  padding: "0.625rem 0.75rem",
  background: "var(--login-bg)",
  border: "1px solid var(--login-border)",
  borderRadius: "0.5rem",
  color: "var(--login-text)",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: "0.9375rem",
  outline: "none",
  boxSizing: "border-box",
  minHeight: "44px",
};

export const orderLabelStyle: CSSProperties = {
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 600,
  fontSize: "0.75rem",
  letterSpacing: "0.06em",
  color: "var(--login-muted)",
};

export const orderActionButtonStyle: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.375rem",
  padding: "0.5rem 0.875rem",
  minHeight: "44px",
  border: "1px solid transparent",
  borderRadius: "0.375rem",
  fontFamily: "'Barlow Condensed', sans-serif",
  fontWeight: 600,
  fontSize: "0.875rem",
  letterSpacing: "0.03em",
  cursor: "pointer",
  lineHeight: 1,
  whiteSpace: "nowrap",
  transition:
    "background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease",
};

export const orderLedgerActionButtonStyle: CSSProperties = {
  ...orderActionButtonStyle,
  minHeight: "34px",
  padding: "0.4rem 0.55rem",
  fontSize: "0.8125rem",
  borderRadius: "0.35rem",
};
